import React from "react";
import ReviewSlider from "../review-slider/reviewSlider";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import "./reviewCarousel.scss";

const ReviewCarousel = (props: ReferenciaContenido) => {

  return (
    <div className="m-review-carousel">
      <div className="m-review-carousel__upper">
        <h2 className="m-review-carousel__upper-title">
          {props.tituloGeneral}
        </h2>
      </div>

      <div className="m-review-carousel__featured">
        {props.referenciaPlantillaContenido && (
          <ReviewSlider 
            reviews={props.referenciaPlantillaContenido} 
            gtmClass={`${normalizeTwoWords(props.nombreCategoria)}${
              normalizeTwoWords(props.tituloGeneral)
            }`} 
          />
        )}
      </div>
    </div>
  );
};

export default ReviewCarousel;
